import { useI18nState } from '../../stores/settings/language-context';

export default function FileNotFound() {
  const { localeData } = useI18nState();
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div className="grc-card d-flex align-items-center justify-content-center text-primary fw-bold">
            <h1>{localeData.PageNotFound}</h1>
          </div>
        </div>
      </div>
    </div>
  );
}
